import { render, staticRenderFns } from "./zsfaRecordList.vue?vue&type=template&id=0eff2237&scoped=true"
import script from "./zsfaRecordList.vue?vue&type=script&lang=js"
export * from "./zsfaRecordList.vue?vue&type=script&lang=js"
import style0 from "./zsfaRecordList.vue?vue&type=style&index=0&id=0eff2237&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eff2237",
  null
  
)

export default component.exports